import { render, staticRenderFns } from "./SubtitlesConfigBottomSheet.vue?vue&type=template&id=7bb4d956&scoped=true"
import script from "./SubtitlesConfigBottomSheet.vue?vue&type=script&lang=js"
export * from "./SubtitlesConfigBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./SubtitlesConfigBottomSheet.vue?vue&type=style&index=0&id=7bb4d956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb4d956",
  null
  
)

export default component.exports